import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useApi, useResource, errorText } from "@/lib/api";
import IssueList from "@/components/dq/IssueList";

export default function DataQualityPage() {
  const api = useApi();
  const navigate = useNavigate();
  const { data, reload } = useResource("/data-quality");
  const [busy, setBusy] = useState(null);

  const fix = async (issue, index) => {
    const f = issue.fixes[index];
    if (f.action === "open_ledger") return navigate(`/ledger?fy=${f.params.fy}&filter=blank`);
    setBusy(issue.key);
    try {
      const res = await api("post", "/data-quality/fix", { key: issue.key, fix: index });
      toast.success(res.applied);
      await reload();
    } catch (e) { toast.error(errorText(e)); }
    setBusy(null);
  };
  const total = data?.issues.length;

  return (
    <div className="rise">
      <h1 className="font-display text-4xl sm:text-5xl font-semibold tracking-tight" data-testid="dq-title">Data quality</h1>
      <p className="mt-3 text-muted-foreground text-base md:text-lg">
        The Section 8 checks as a to-do list. Every fix is one click and is recorded in the audit log.
      </p>
      {data && (
        <div className="mt-6 mb-8 font-mono text-sm" data-testid="dq-total">
          {total ? <span className="text-amber-300">{total} items to review</span> : <span className="text-emerald-300">Everything looks clean</span>}
        </div>
      )}
      {data && <IssueList checks={data} onFix={fix} busyKey={busy} />}
    </div>
  );
}
